import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=2ac4e62d&"
import script from "./EditTemplate.vue?vue&type=script&lang=js&"
export * from "./EditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac4e62d')) {
      api.createRecord('2ac4e62d', component.options)
    } else {
      api.reload('2ac4e62d', component.options)
    }
    module.hot.accept("./EditTemplate.vue?vue&type=template&id=2ac4e62d&", function () {
      api.rerender('2ac4e62d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/component/EditTemplate.vue"
export default component.exports